import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Checkbox,
  Button,
  Divider,
  IconButton,
} from "@mui/material";
import "./TextScreen.css";
import logo from "../assets/logo.png";
import { getTextById, getTextByLanguage } from "../api/text";
import CloseIcon from "@mui/icons-material/Close";
import PoweredByTipify from "../components/PoweredByTipify";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TextScreen = ({ id, showDataDeletionLink = false }) => {
  const { t } = useTranslation();
  const [text, setText] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const textRes = await getTextById(id);
      if (textRes.status === 200) {
        setText(getTextByLanguage(textRes.data.content));
      }
    };
    fetchData();
  }, [id]);

  const closeWindow = () => {
    // Cierra la ventana actual
    window.close();
    // Regresa a la ventana principal
    if (window.opener) {
      window.opener.location.reload(); // Esto recarga la ventana principal, puedes cambiarlo según lo que necesites
    }
  };

  return (
    <Container className="container-fluid">
      <div className="header">
        {/* Logo */}
        <div className="logo-container mt-3">
          <img src={logo} alt="Tipify Logo" className="logo2" />
        </div>
        {/* Botón de cierre (X) */}
        <IconButton
          onClick={closeWindow}
          sx={{
            "& .MuiSvgIcon-root": {
              fontSize: "2.7rem !important",
              color: "black",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <div dangerouslySetInnerHTML={{ __html: text }} />
      {showDataDeletionLink && (
        <p style={{ margin: "24px 0" }}>
          <Link to="/eliminar-datos">{t("dataDeletion.title")}</Link>
        </p>
      )}
      <PoweredByTipify />
    </Container>
  );
};

export default TextScreen;
